(function () {
  'use strict';

  function money(cents, currency) {
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2);
    }
  }

  /* Gallery thumbnails + arrows */
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var main = gallery.querySelector('[data-gallery-main]');
    var thumbs = gallery.querySelectorAll('[data-thumb]');
    var strip = gallery.querySelector('[data-thumbs]');
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (main) main.src = thumb.dataset.src;
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
    var prev = gallery.querySelector('[data-thumbs-prev]');
    var next = gallery.querySelector('[data-thumbs-next]');
    if (strip && prev) prev.addEventListener('click', function () { strip.scrollBy({ left: -strip.clientWidth * 0.8 }); });
    if (strip && next) next.addEventListener('click', function () { strip.scrollBy({ left: strip.clientWidth * 0.8 }); });
  });

  /* Media slider arrows */
  document.querySelectorAll('.slider-wrap').forEach(function (wrap) {
    var slider = wrap.querySelector('[data-slider]');
    var p = wrap.querySelector('[data-slider-prev]');
    var n = wrap.querySelector('[data-slider-next]');
    if (!slider) return;
    if (p) p.addEventListener('click', function () { slider.scrollBy({ left: -slider.clientWidth * 0.8 }); });
    if (n) n.addEventListener('click', function () { slider.scrollBy({ left: slider.clientWidth * 0.8 }); });
  });

  /* Product: variants, bundles, countdown, add to cart */
  document.querySelectorAll('[data-product-form]').forEach(function (box) {
    var root = box.closest('[data-product]') || document;
    var currency = (root.dataset && root.dataset.currency) || 'USD';
    var dataEl = box.querySelector('[data-variants]');
    var variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { /* ignore */ }
    var idInput = box.querySelector('[data-variant-id]');
    var priceEl = box.querySelector('[data-price]');
    var compareEl = box.querySelector('[data-compare]');
    var addBtn = box.querySelector('[data-add]');
    var fieldsets = box.querySelectorAll('.opt');
    var form = box.querySelector('form');
    var bundle = box.querySelector('[data-bundle]');
    var tiers = bundle ? bundle.querySelectorAll('[data-tier]') : [];
    var current = variants.length ? variants[0] : null;

    function byId(id) {
      return variants.find(function (v) { return String(v.id) === String(id); });
    }

    function selectedTier() {
      var t = null;
      tiers.forEach(function (el) { if (el.classList.contains('is-selected')) t = el; });
      return t;
    }

    function renderTiers() {
      if (!current) return;
      tiers.forEach(function (el) {
        var qty = parseInt(el.dataset.qty, 10) || 1;
        var disc = parseFloat(el.dataset.discount) || 0;
        var unit = current.price;
        var full = (current.compare_at_price && current.compare_at_price > unit ? current.compare_at_price : unit) * qty;
        var total = Math.round(unit * qty * (100 - disc) / 100);
        var p = el.querySelector('[data-tier-price]');
        var c = el.querySelector('[data-tier-compare]');
        if (p) p.textContent = money(total, currency);
        if (c) {
          if (full > total) { c.textContent = money(full, currency); c.hidden = false; } else { c.hidden = true; }
        }
        el.querySelectorAll('[data-mix-select]').forEach(function (sel) {
          if (!sel.dataset.touched) sel.value = String(current.id);
        });
      });
    }

    function update() {
      var selected = [];
      fieldsets.forEach(function (fs) {
        var checked = fs.querySelector('input:checked');
        var value = checked ? checked.value : '';
        selected.push(value);
        var label = fs.querySelector('[data-option-label]');
        if (label) label.textContent = value;
      });
      if (fieldsets.length) {
        var match = variants.find(function (v) {
          return v.options.every(function (o, i) { return o === selected[i]; });
        });
        if (!match) {
          addBtn.disabled = true;
          addBtn.textContent = 'Unavailable';
          return;
        }
        current = match;
      }
      if (!current) return;
      idInput.value = current.id;
      priceEl.textContent = money(current.price, currency);
      if (compareEl) {
        if (current.compare_at_price && current.compare_at_price > current.price) {
          compareEl.textContent = money(current.compare_at_price, currency);
          compareEl.hidden = false;
        } else { compareEl.hidden = true; }
      }
      addBtn.disabled = !current.available;
      addBtn.textContent = current.available ? 'Add to cart' : 'Sold out';
      if (current.featured_media) {
        var thumb = root.querySelector('[data-thumb][data-media-id="' + current.featured_media.id + '"]');
        if (thumb) thumb.click();
      }
      renderTiers();
    }

    fieldsets.forEach(function (fs) { fs.addEventListener('change', update); });

    tiers.forEach(function (el) {
      el.addEventListener('click', function (e) {
        if (e.target.closest('select, input, label')) {
          if (!el.classList.contains('is-selected')) { /* fall through and select */ } else { return; }
        }
        tiers.forEach(function (t) { t.classList.remove('is-selected'); });
        el.classList.add('is-selected');
      });
      el.querySelectorAll('[data-mix-select]').forEach(function (sel) {
        sel.addEventListener('change', function () { sel.dataset.touched = '1'; });
      });
    });

    /* Countdown to a real end date, hidden once it has passed */
    var cd = box.querySelector('[data-countdown]');
    if (cd) {
      var end = new Date(cd.dataset.countdown.replace(' ', 'T'));
      var text = cd.querySelector('[data-countdown-text]');
      var tick = function () {
        var left = end - new Date();
        if (isNaN(end) || left <= 0) { cd.hidden = true; return false; }
        cd.hidden = false;
        var s = Math.floor(left / 1000);
        var h = String(Math.floor(s / 3600)).padStart(2, '0');
        var m = String(Math.floor((s % 3600) / 60)).padStart(2, '0');
        var sec = String(s % 60).padStart(2, '0');
        text.textContent = h + ':' + m + ':' + sec;
        return true;
      };
      if (tick()) {
        var timer = setInterval(function () { if (!tick()) clearInterval(timer); }, 1000);
      }
    }

    /* Add to cart: single variant uses the normal form, bundles use /cart/add.js */
    if (form && tiers.length) {
      form.addEventListener('submit', function (e) {
        var tier = selectedTier();
        if (!tier || !current) return;
        e.preventDefault();
        var qty = parseInt(tier.dataset.qty, 10) || 1;
        var ids = {};
        var mixed = tier.querySelectorAll('[data-mix-select]');
        if (mixed.length) {
          mixed.forEach(function (sel) { ids[sel.value] = (ids[sel.value] || 0) + 1; });
        } else {
          ids[current.id] = qty;
        }
        var items = Object.keys(ids).map(function (id) { return { id: parseInt(id, 10), quantity: ids[id] }; });
        tier.querySelectorAll('[data-addon]').forEach(function (a) {
          var cb = a.querySelector('.addon-check');
          if (cb && cb.checked) items.push({ id: parseInt(a.dataset.variant, 10), quantity: 1 });
        });
        addBtn.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        }).then(function (r) {
          if (!r.ok) throw new Error('add failed');
          window.location.href = '/cart';
        }).catch(function () {
          addBtn.disabled = false;
          form.submit();
        });
      });
    }

    update();
  });
})();
